import { render, staticRenderFns } from "./patrol-resolution.vue?vue&type=template&id=ca528424&scoped=true"
import script from "./patrol-resolution.vue?vue&type=script&lang=js"
export * from "./patrol-resolution.vue?vue&type=script&lang=js"
import style0 from "./patrol-resolution.vue?vue&type=style&index=0&id=ca528424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca528424",
  null
  
)

export default component.exports